<template>
  <v-card width="350">
    <v-card-subtitle>{{ $vuetify.lang.t('$vuetify.videoSettings.title') }}</v-card-subtitle>
    <v-divider></v-divider>
    <v-card-text>
      <span class="caption">{{ $vuetify.lang.t('$vuetify.videoSettings.videoWidth') }}</span>
      <v-slider v-model="videoWidth" color="blue"
                min="5" max="12" ticks="always" tick-size="4" step="1"
                ></v-slider>
      <span class="caption">{{ $vuetify.lang.t('$vuetify.videoSettings.videoRoadWidth') }}</span>
      <v-slider v-model="videoRoadWidth" color="blue"
                min="5" max="12" ticks="always" tick-size="4" step="1"
      ></v-slider>
      <v-checkbox class="shrink mt-0 mx-auto px-1 mr-sm-3" v-model="autoPlayVideo"
                  :label="$vuetify.lang.t('$vuetify.videoSettings.autoPlayVideo')">
      </v-checkbox>
    </v-card-text>
  </v-card>
</template>

<script>
import { SETTINGS_MODULE } from '../../../store/modules'
import { createHelpers } from 'vuex-map-fields'

const { mapFields } = createHelpers({
  getterType: `${SETTINGS_MODULE}/getField`,
  mutationType: `${SETTINGS_MODULE}/updateField`
})

export default {
  name: 'videoSettingsCard',
  computed: {
    ...mapFields(['videoSettings.videoWidth', 'videoSettings.videoRoadWidth', 'videoSettings.autoPlayVideo'])
  }
}
</script>

<style scoped>

</style>
